import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type CostDistributionQueryVariables = {};


export type CostDistributionQuery = (
  { __typename?: 'Query' }
  & { provingGrounds: Array<(
    { __typename?: 'ProvingGround' }
    & Pick<Types.ProvingGround, '_id' | 'title'>
    & { testTracks: Types.Maybe<Array<(
      { __typename?: 'TestTrack' }
      & Pick<Types.TestTrack, '_id' | 'title'>
      & { usages: Array<(
        { __typename?: 'TestTrackUsage' }
        & Pick<Types.TestTrackUsage, '_id' | 'title'>
      )> }
    )>>, offices: Types.Maybe<Array<(
      { __typename?: 'Office' }
      & Pick<Types.Office, '_id' | 'title'>
    )>>, workstations: Types.Maybe<Array<(
      { __typename?: 'Workstation' }
      & Pick<Types.Workstation, '_id' | 'title'>
    )>>, garages: Types.Maybe<Array<(
      { __typename?: 'Garage' }
      & Pick<Types.Garage, '_id' | 'title'>
    )>>, liftingPlatforms: Types.Maybe<Array<(
      { __typename?: 'LiftingPlatform' }
      & Pick<Types.LiftingPlatform, '_id' | 'title'>
    )>>, coldcells: Types.Maybe<Array<(
      { __typename?: 'ColdCell' }
      & Pick<Types.ColdCell, '_id' | 'title'>
    )>>, accomodations: Types.Maybe<Array<(
      { __typename?: 'Lodging' }
      & Pick<Types.Lodging, '_id' | 'title'>
    )>>, radios: Types.Maybe<Array<(
      { __typename?: 'Accessory' }
      & Pick<Types.Accessory, '_id' | 'title'>
    )>>, accessCards: Types.Maybe<Array<(
      { __typename?: 'Accessory' }
      & Pick<Types.Accessory, '_id' | 'title'>
    )>>, fuelCards: Types.Maybe<Array<(
      { __typename?: 'Refuelling' }
      & Pick<Types.Refuelling, '_id' | 'title'>
    )>>, buildings: Types.Maybe<Array<(
      { __typename?: 'Building' }
      & Pick<Types.Building, '_id' | 'title'>
    )>> }
  )> }
);

export type GenerateCostDistributionMutationVariables = {
  input: Types.CostDistributionReportInput
};


export type GenerateCostDistributionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'generateCostDistribution'>
);

export const CostDistributionDocument = gql`
    query costDistribution {
  provingGrounds(filter: {inactive: {EQ: false}}) {
    _id
    title
    testTracks {
      _id
      title
      usages {
        _id
        title
      }
    }
    offices {
      _id
      title
    }
    workstations {
      _id
      title
    }
    garages {
      _id
      title
    }
    liftingPlatforms {
      _id
      title
    }
    coldcells {
      _id
      title
    }
    accomodations {
      _id
      title
    }
    radios {
      _id
      title
    }
    accessCards {
      _id
      title
    }
    fuelCards {
      _id
      title
    }
    buildings {
      _id
      title
    }
  }
}
    `;

    export function useCostDistributionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CostDistributionQuery, CostDistributionQueryVariables>) {
      return ApolloReactHooks.useQuery<CostDistributionQuery, CostDistributionQueryVariables>(CostDistributionDocument, baseOptions);
    };
      export function useCostDistributionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CostDistributionQuery, CostDistributionQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<CostDistributionQuery, CostDistributionQueryVariables>(CostDistributionDocument, baseOptions);
      };
      
export type CostDistributionQueryHookResult = ReturnType<typeof useCostDistributionQuery>;
export type CostDistributionQueryResult = ApolloReactCommon.QueryResult<CostDistributionQuery, CostDistributionQueryVariables>;
export const GenerateCostDistributionDocument = gql`
    mutation generateCostDistribution($input: CostDistributionReportInput!) {
  generateCostDistribution(input: $input)
}
    `;
export type GenerateCostDistributionMutationFn = ApolloReactCommon.MutationFunction<GenerateCostDistributionMutation, GenerateCostDistributionMutationVariables>;

    export function useGenerateCostDistributionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateCostDistributionMutation, GenerateCostDistributionMutationVariables>) {
      return ApolloReactHooks.useMutation<GenerateCostDistributionMutation, GenerateCostDistributionMutationVariables>(GenerateCostDistributionDocument, baseOptions);
    };
export type GenerateCostDistributionMutationHookResult = ReturnType<typeof useGenerateCostDistributionMutation>;
export type GenerateCostDistributionMutationResult = ApolloReactCommon.MutationResult<GenerateCostDistributionMutation>;
export type GenerateCostDistributionMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateCostDistributionMutation, GenerateCostDistributionMutationVariables>;